import React, { forwardRef } from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.css";
const DatePicker = (props) => {
  const {
    selected,
    onChange,
    dateFormat,
    placeholderText,
    minDate,
    maxDate,
    filterDate,
    isClearable,
    showYearDropdown,
    scrollableMonthYearDropdown,
    wrapperClassName,
    style,
    name,
    disabled,
    highlightDates,
    selectsStart,
    selectsEnd,
    startDate,
    endDate,
    // onClick
  } = props;
  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      value={value}
      className="custom-input"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
      placeholder={placeholderText}
      style={style}
      disabled={disabled}
      // required={true}
    ></input>
  ));
  return (
    <>
      <Datepicker
        selected={selected} //need this
        onChange={onChange} // need this
        dateFormat={dateFormat}
        // onClick={onClick}
        minDate={minDate}
        maxDate={maxDate}
        filterDate={filterDate}
        isClearable={isClearable}
        showYearDropdown={showYearDropdown}
        scrollableMonthYearDropdown={scrollableMonthYearDropdown}
        wrapperClassName={wrapperClassName}
        name={name}
        // required={true}
        style={style}
        disabled={disabled}
        highlightDates={highlightDates}
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        startDate={startDate}
        endDate={endDate}
        customInput={<CustomInput />}
      />
    </>
  );
};

export default DatePicker;
